import AuthService from "./authService";

export const authService = new AuthService();
